module.exports = (__webpack_require__(11))(36);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/redux/es/index.js from dll-reference vendor_lib
// module id = 756
// module chunks = 0